import { useState } from "react";
import MenuFrame from "../frames/menu_frame";
import { getClientList } from "../booking/booking_halper";
import TrayItem from "../frames/tray_item";

function BillingCompany() {
    const [apps, setApps] = useState([]);
    const [appList, setAppList] = useState(apps);

    const initData = async (auth) => {
        if (!auth) return;
        try {
            const client = await getClientList("billing");
            for (let idx = 0; idx < client.length; idx++) {
                client[idx]["description"] = client[idx]["client_id"];
                client[idx]["caption"] = client[idx]["gst_num"];
                client[idx]["link"] = client[idx]["client_id"];
            }
            console.log(client);
            setAppList(client);
            setApps(client);
        } catch (err) {
            console.error(err);
        }
    }

    const handleSearch = (e) => {
        const txt = e.target.value.trim().toLowerCase();
        if (txt === "") setAppList(apps);
        setAppList(apps.filter((i) => i.name.toLowerCase().includes(txt) || i.client_id.toLowerCase().includes(txt)));
    }

    return (
        <MenuFrame onSearch={handleSearch} permission="BILLING_ORG" screen={"BILLING"} onInit={initData}>
            <TrayItem items={appList} showicon={false} />
        </MenuFrame>
    );
}

export default BillingCompany;